import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Footer from '../components/Footer';

const TermsOfUse = () => {
  const { t, i18n } = useTranslation();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await axios.get(
          `https://www.jobya.pro/api/api/public/termos-uso/${i18n.language}`
        );
        setContent(response.data);
      } catch (error) {
        console.error('Error fetching terms:', error);
        setContent('Terms of Use content could not be loaded.');
      } finally {
        setLoading(false);
      }
    };

    fetchTerms();
  }, [i18n.language]);

  return (
    <div>
      <div className="section" style={{ marginTop: '80px', minHeight: '60vh' }}>
        <div className="container">
          <h2>{t('footer.termsOfUse')}</h2>
          <div className="legal-document-form">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <div dangerouslySetInnerHTML={{ __html: content }} />
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfUse;
